<template>
  <div v-if="location != []">
    <vs-divider />
    <br />
    <vs-row>
      <vs-col
        vs-type="flex"
        vs-justify="flex-start"
        vs-align="center"
        vs-w="12"
      >
        <div id="div-with-loading" class="vs-con-loading__container">
          <DxTreeList
            key-expr="id"
            parent-id-expr="HeadID"
            id="treeList"
            :data-source="assetArr"
            :root-value="-1"
            :auto-expand-all="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :column-auto-width="true"
            @selection-changed="selectEmployee"
            @row-inserting="onRowInserting"
            @row-updating="updating"
            @row-removing="validateRemove"
          >
            <DxColumn data-field="name" :fixed="true">
              <DxRequiredRule />
            </DxColumn>

            <DxColumn type="buttons">
              <DxButton name="add" icon="add" />
              <DxButton name="edit" icon="edit" />
              <DxButton name="delete" icon="trash" />
              <DxButton
                hint="Clone"
                icon="copy"
                :visible="isCloneIconVisible"
                :disabled="isCloneIconDisabled"
                @click="cloneIconClick"
              />
            </DxColumn>
            <DxColumnFixing :enabled="true" />
            <DxColumnChooser :enabled="true" />
            <DxFilterRow :visible="true" />
            <DxSearchPanel :visible="true" />
            <DxSelection mode="single" />

            <DxEditing
              mode="popup"
              :allow-updating="true"
              :allow-adding="true"
              :allow-deleting="true"
            >
            </DxEditing>

            <DxRowDragging
              :on-drag-change="onDragChange"
              :on-reorder="onReorder"
              :allow-drop-inside-item="true"
              :allow-reordering="true"
              :show-drag-icons="true"
            />

            <DxPaging :enabled="true" :page-size="10" />
          </DxTreeList>
        </div>
      </vs-col>
    </vs-row>

    <b-modal
      id="AssetDetails"
      title="Asset information"
      hide-footer
      centered
      size="xl"     
      hide-header-close      
      v-if="selectedEmployee != undefined"
    >
      <h3>{{ selectedEmployee.name }}</h3>
      <br />
      <div class="holamundo">
        <vs-tabs :color="color_tab">
          <vs-tab @click="color_tab = 'success'" label="Details">
            <TabDetail
              :options1="options1"
              :assetdata="selectedEmployee"
              :textTypeData="assetArr"
            />
          </vs-tab>

          <vs-tab @click="color_tab = 'success'" label="Document">
            <TabDocument />
          </vs-tab>

          <vs-tab @click="color_tab = 'success'" label="WR">
            <TabWR />
          </vs-tab>

          <vs-tab @click="color_tab = 'success'" label="WO">
            <TabWO :priority="priority" />
          </vs-tab>

          <vs-tab @click="color_tab = 'success'" label="PM">
            <TabPM />
          </vs-tab>

          <vs-tab @click="color_tab = 'success'" label="Log">
            <TabLog />
          </vs-tab>

          <vs-tab @click="color_tab = 'success'" label="Sensor">
            <TabSensor />
          </vs-tab>

          <vs-tab @click="color_tab = 'success'" label="Alert">
            <TabAlert />
          </vs-tab>

          <vs-tab @click="color_tab = 'success'" label="Spare Part">
            <TabSparePart />
          </vs-tab>

          <vs-tab @click="color_tab = 'success'" label="Vendor">
            <TabVendor />
          </vs-tab>

          <vs-tab @click="color_tab = 'success'" label="Setting">
            <div class="con-tab-ejemplo">???</div>
          </vs-tab>

        </vs-tabs>
      </div>
    </b-modal>
  </div>
</template>

<script>
import TabDetail from "@/TreeListMaster/Tabs/TabDetail";
import TabWO from "@/TreeListMaster/Tabs/TabWO";
import TabWR from "@/TreeListMaster/Tabs/TabWR";
import TabPM from "@/TreeListMaster/Tabs/TabPM";
import TabLog from "@/TreeListMaster/Tabs/TabLog";
import TabSparePart from "@/TreeListMaster/Tabs/TabSparePart";
import TabDocument from "@/TreeListMaster/Tabs/TabDocument";
import TabVendor from "@/TreeListMaster/Tabs/TabVendor";
import TabSensor from "@/TreeListMaster/Tabs/TabSensor";
import TabAlert from "@/TreeListMaster/Tabs/TabAlert";
import {
  DxTreeList,
  DxColumn,
  DxRequiredRule,
  DxColumnChooser,
  DxColumnFixing,
  DxFilterRow,
  DxSearchPanel,
  DxSelection,
  DxEditing,
  DxButton,
  DxRowDragging,
  DxPaging,
  DxTexts,
} from "devextreme-vue/tree-list";

export default {
  components: {
    TabDetail,
    TabWO,
    TabPM,
    TabLog,
    TabSparePart,
    TabWR,
    DxTreeList,
    DxColumn,
    DxRequiredRule,
    DxColumnChooser,
    DxColumnFixing,
    DxFilterRow,
    DxSearchPanel,
    DxSelection,
    DxEditing,
    DxRowDragging,
    DxPaging,
    DxTexts,
    TabDocument,
    DxButton,
    TabVendor,
    TabSensor,
    TabAlert,
  },
  props: {
    location,
    locationall: Array,
  },

  data() {
    return {
      priority: [
        { text: "🛠️ Low Priority", value: 1 },
        { text: "🛠️ Medium Priority", value: 2 },
        { text: "🛠️ High Priority ", value: 3 },
      ],
      options1: [
        { text: "Asset Type", value: 0 },
        { text: "Location", value: 2 },
        { text: "Quality", value: 3 },
      ],
      color_tab: "success",
      viewassetdetail: {},
      employees: [],
      selectedEmployee: {},
      assetArr: [],
    };
  },

  mounted() {
    if (this.location != undefined) {
      this.getAsset(this.location);
    }
  },
  methods: {
    getAsset(location) {
      let body = {
        location_id: 8,
      };
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 0.8,
      });
      this.$API
        .get("asset/all-attr-assets", body)
        .then((res) => {
          this.employees = res.data.data;
          this.assetArr = res.data.data;

          setTimeout(() => {
            this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          }, 1000);
        })
        .catch((res) => {
          setTimeout(() => {
            this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          }, 1000);
        });
    },
    updating(e) {
      console.log(e); //Event การอัพเดทชื่อ
      let data = {
        id: e.oldData.id,
        name: e.newData.name,
        brand: e.newData.brand,
        type: e.newData.type,
        model: e.newData.model,
        warranty_date: e.newData.warranty_date,
      };
      console.log(data);
      this.$API.post("asset/update-asset", data).then((res) => {
        if (res.status == 200)
          this.$vs.notify({
            title: "Asset Update",
            text: res.data.message,
            color: "primary",
            position: "top-center",
          });
      });
    },
    validateRemove(e) {
      console.log(e.data.id); //Event การลบชื่อ
      let body = { id: e.data.id };
      console.log(body);

      this.$API.post("asset/delete-asset", body).then((res) => {
        console.log(res);
        if (res.status == 200)
          this.$vs.notify({
            title: "Asset Delete",
            text: res.data.message,
            color: "primary",
            position: "top-center",
          });
      });
    },
    onRowInserting(e) {
      //Add MOM
      // Handler of the "rowInserting" event
      console.log(e, "P1"); //Event การเพิ่มชื่อ

      let data = {
        name: e.data.name,
        brand: e.data.brand,
        type: e.data.type,
        model: e.data.model,
        warranty_date: e.data.warranty_date,
        location_id: this.location.id,
        HeadID: e.data.HeadID,
      };
      this.$API.post("asset/create-asset", data).then((res) => {
        if (res.status == 200)
          this.$vs.notify({
            title: "Asset Create",
            text: res.data.message,
            color: "primary",
            position: "top-center",
          });
        else if (res.status != 200)
          this.$vs.notify({
            title: "Asset Create",
            text: res.data.message,
            color: "danger",
            position: "top-center",
          });
      });
    },
    selectEmployee(e) {
      e.component.byKey(e.currentSelectedRowKeys[0]).done((employee) => {
        if (employee) {
          this.$bvModal.show("AssetDetails");
          console.log(employee, "test22"); //Event การกดคลิกที่ชื่อ
          this.selectedEmployee = employee;
        }
      });
    },
    onDragChange(e) {
      let visibleRows = e.component.getVisibleRows(),
        sourceNode = e.component.getNodeByKey(e.itemData.id),
        targetNode = visibleRows[e.toIndex].node;

      while (targetNode && targetNode.data) {
        if (targetNode.data.id === sourceNode.data.id) {
          e.cancel = true;
          break;
        }
        targetNode = targetNode.parent;
      }
    },
    onReorder(e) {
      console.log(e);
      console.log("P3");
      let visibleRows = e.component.getVisibleRows(),
        sourceData = e.itemData,
        targetData = visibleRows[e.toIndex].data;
      console.log(sourceData, "Child"); // Id ของคนที่อยู่ที่ปลายเมาส์ที่โดนจับโยกไปเป็นลูกกะจ๊อกของคนอื่น อันนี้ HeadID จะอัพเดทเอง
      console.log(targetData, "Mom"); // Id ปลายทางที่ลูกกะจ๊อกจะไปอยู่ด้วย
      if (e.dropInsideItem) {
        e.itemData.HeadID = targetData.id;
        e.component.refresh();
      } else {
        let sourceIndex = this.employees.indexOf(sourceData),
          targetIndex = this.employees.indexOf(targetData);

        if (sourceData.HeadID !== targetData.HeadID) {
          sourceData.HeadID = targetData.HeadID;
          if (e.toIndex > e.fromIndex) {
            targetIndex++;
          }
        }

        this.employees.splice(sourceIndex, 1);
        this.employees.splice(targetIndex, 0, sourceData);

        this.employees = this.employees.slice();
      }
      let data = {
        id: sourceData.id,
        HeadID: sourceData.HeadID,
      };
      console.log(data, "PP");
      this.$API.post("asset/drag-and-drop-asset", data).then((res) => {
        if (res.status == 200)
          if (res.status == 200)
            this.$vs.notify({
              title: "Asset Update",
              text: res.data.message,
              color: "primary",
              position: "top-center",
            });
          else if (res.status != 200)
            this.$vs.notify({
              title: "Asset Update",
              text: res.data.message,
              color: "danger",
              position: "top-center",
            });
      });
    },
    cloneIconClick(e) {
      console.log(e);
      const employees = [...this.employees];
      const clonedItem = { ...e.row.data, ID: service.getMaxID() };

      employees.splice(e.row.rowIndex, 0, clonedItem);
      this.employees = employees;
      e.event.preventDefault();
    },
    getAssetInfo() {},
  },
};
</script>

<style lang="scss">
.popup-example {
  .vs-input {
    float: left;
    width: 50%;
    margin: 10px;
    margin-top: 5px;
  }

  .con-select {
    margin-left: 10px;
    width: 50%;
    margin-bottom: 10px;
  }

}
</style>

<style lang="scss"  scoped>
#treeList {
  height: 100%;
}

#app-container {
  width: 100%;
  position: relative;
}

#selected-employee {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
}
.vtl {
  .vtl-drag-disabled {
    background-color: #d0cfcf;
    &:hover {
      background-color: #d0cfcf;
    }
  }
  .vtl-disabled {
    background-color: #d0cfcf;
  }
}
.icon {
  &:hover {
    cursor: pointer;
  }
}
.vuesax-app-is-ltr .includeIcon[data-v-368d65b7] {
  float: none;
  margin-left: 0%;
  width: 15%;
}
.muted {
  color: gray;
  font-size: 80%;
}

.lo_icon {
  width: 23px;
}
// .shadow2 {
//   box-shadow: inset 0px 0px 3px 3px #dddddd;
//   background: #edecec;
//   -moz-appearance: none;
//   appearance: none;
//   border-width: 0;
//   border-radius: 5px;
//   height: 25px;
// }
.vuesax-app-is-ltr .includeIcon {
  float: none;
  margin-left: 2%;
}
// input {
//   box-shadow: inset 0px 0px 5px 5px #dddddd;
//   background: #edecec;
//   -moz-appearance: none;
//   appearance: none;
//   border-width: 0; /* if y50ou don't want the border */
//   border-radius: 12px;
//   height: 35px;
//   text-align: center;
// }
.holamundo {
  width: 100%;
}

.detail-name {
  font-size: 15px;
}

.mock-img {
  width: 150px;
}
.iconslot {
  margin-left: 100px;
}
</style>
<style scope>
/* .vdatetime-input {
  border-radius: 12px;
  box-shadow: inset 0px 0px 5px 5px #dddddd;
  background: #edecec;
  border: none;
  height: 35px;
  text-align: center;
} */
/* .vuesax-app-is-ltr .vs-select--input {
  border-radius: 12px;
  box-shadow: inset 0px 0px 5px 5px #dddddd;
  background-color: #f0f0f0;
} */
</style>
